jQuery(document).ready(function ($) {
    $('.js--scroll-to-offset').on('click', scrollNextWithAnimation);

    function scrollNextWithAnimation(event) {
        event.preventDefault();
        var next = $(this).parentsUntil(".section").parent().next();

        $('html, body').animate({scrollTop: next.offset().top}, 800);
    }
});